import React from 'react';
import { HelpCircle } from 'lucide-react';
import { iconMap } from './iconMap';

const sizeMap = {
  xs: '16px',
  sm: '20px',
  md: '24px',
  lg: '32px',
  xl: '48px',
};

// Renders a Lucide icon, looked up by its legacy Material Icons name. The
// rendered SVG keeps the `material-icons` class (plus any passed className) so
// existing CSS that sizes/colors icons via `font-size`/`color` keeps working.
// The SVG is sized at 1em, so it scales with the inherited/CSS font-size.
const Icon = ({
  name,
  children,
  size,
  color = 'currentColor',
  className = '',
  style,
  strokeWidth = 2,
  ...props
}) => {
  const key = String(name != null ? name : typeof children === 'string' ? children : '').trim();
  const LucideIcon = iconMap[key] || HelpCircle;
  const fontSize = size ? sizeMap[size] || size : undefined;

  return (
    <LucideIcon
      className={['material-icons', className].filter(Boolean).join(' ')}
      color={color}
      strokeWidth={strokeWidth}
      width="1em"
      height="1em"
      aria-hidden="true"
      style={{ width: '1em', height: '1em', ...(fontSize ? { fontSize } : {}), ...style }}
      {...props}
    />
  );
};

export default Icon;
